<template>
  <v-container fluid no-gutters class="pa-0 d-flex flex-column" style="height: 100%">
    <navbar-panel>
      <template #[`content.prepend`]>
        <v-col cols="auto" class="border-left ml-5" style="height: 25px" />
        <v-col cols="12" class="flex-shrink-1 pl-3">
          <the-navbar-top-panel />
        </v-col>
      </template>
    </navbar-panel>
    <the-navbar-tools-panel />
  </v-container>
</template>

<script>
import NavbarPanel from '@/components/NavbarPanel';
import TheNavbarToolsPanel from '@/components/TheNavbarToolsPanel';
import TheNavbarTopPanel from '@/components/TheNavbarTopPanel';

export default {
  name: 'TheNavbar',
  components: { NavbarPanel, TheNavbarToolsPanel, TheNavbarTopPanel },
};
</script>

<style lang="scss" scoped>
.border-left {
  @include border(left);
}
</style>
